import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './Analyze.scss';

import { BotsCreators } from '../../../store/actions/bots';

/**
 * Component for abstract the html container element for report components
 *
 * @param {*} props
 * @returns
 */
const ContainerReport = (props) => {
  const {
    type,
    icon,
    title,
    match,
    containerContent,
    retrieveBotRequest,
    draggableId,
    onRemoveClick,
    isEditMode,
    containerCustomClass,
    bodyInfoCustomClass,
    headerCustomClass,
    renderRightTitleContent,
  } = props;
  const containerClass = type === 'graphic' ? 'grafico-user' : 'info-relatorio';
  const titleMargin = { marginLeft: type === 'graphic' ? 625 : 35 };
  const { botId } = match.params;
  /**
   * Called when component is mount and retrieve the bot data
   */
  useEffect(() => {
    if (botId) {
      retrieveBotRequest(botId);
    }
  }, [botId]);

  /**
   * Render the remove dashboard button when the report component is in user dashboard context
   */
  const renderRemoveDashboardButton = () => {
    if (!!onRemoveClick && !!draggableId && isEditMode) {
      return (
        <div
          className="dashboard-remove-button"
          style={titleMargin}
          onClick={() => onRemoveClick(draggableId)}
        >
          X
        </div>
      );
    }
  };

  return (
    <div
      className={`container-${containerClass} ${containerCustomClass || ''}`}
    >
      <div className={`header-${containerClass} ${headerCustomClass || ''}`}>
        <div className="container-attendance-bot-title">
          <img src={icon} />
          <p>{title}</p>
          {!!renderRightTitleContent ? renderRightTitleContent : false}
        </div>
        {renderRemoveDashboardButton()}
      </div>
      <div className={`body-info-relatorio ${bodyInfoCustomClass || ''}`}>
        {containerContent}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bot: state.bots.bot,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...BotsCreators }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContainerReport)
);
